import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import Store from './store'
import { Loading } from 'components/Common'
import UnsupportedBrowserModal from 'components/UnsupportedBrowserModal'
import { isMicrosoftEdge } from 'assets/js/isMicrosoftEdge'

import './assets/styles/index.scss'
import 'antd/dist/antd.css'

// import 'ant.less'
import './assets/styles/_variables.scss'

import * as serviceWorker from './serviceWorker'

const App = React.lazy(() => import('./App'))

ReactDOM.render(
  isMicrosoftEdge() ? (
    <UnsupportedBrowserModal />
  ) : (
    <Provider store={Store}>
      <React.Suspense fallback={<Loading />}>
        <App />
      </React.Suspense>
    </Provider>
  ),
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
